import { SAMPLE_FORMATTED_TIMESTAMP } from '@cli-constants/generators.js'
export function sampleAdminMedia(): Record<string, unknown> {
  return {
    id: 'media-id',
    url: 'https://example.com/media.jpg',
    filename: 'media.jpg',
    contentType: 'image/jpeg',
    size: 102400,
    width: 1200,
    height: 800,
    alt: 'Example media',
    tags: ['example'],
    createdAt: '2026-01-01T00:00:00.000Z',
    updatedAt: '2026-01-01T00:00:00.000Z',
    createdAtFormatted: SAMPLE_FORMATTED_TIMESTAMP,
    updatedAtFormatted: SAMPLE_FORMATTED_TIMESTAMP,
    createdBy: 'user-id',
    updatedBy: 'user-id'
  }
}
